import React, { FC } from 'react'
import { ContainerButtons, ModalBody, ModalContainer, LargeText, Title, Action } from './styled'
import { Button } from 'views/components/UI/Buttons'
import Modal from 'views/components/UI/Modal'

interface AdminManagementPermissionModalProps {
  isClosed: boolean
  setIsClosed: (value: boolean) => void
  handleCloseClick: () => void
  handleConfirmClick: () => void
  currentValue: boolean
  companyName: string
}

const AdminManagementPermissionModal: FC<AdminManagementPermissionModalProps> = ({
  isClosed,
  setIsClosed,
  handleCloseClick,
  handleConfirmClick,
  currentValue,
  companyName,
}) => {
  return (
    <Modal
      show={!isClosed}
      setShow={setIsClosed}
      hideCloseButton={true}
      styleContent={{
        width: '50%',
        height: 'auto',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
      }}
    >
      <ModalContainer>
        <ModalBody>
          <Title>
            {currentValue
              ? '¿Seguro que deseas revocar los permisos de gestión de administradores?'
              : `¿Seguro que deseas dar permisos sobre los administradores de plataforma?`}
          </Title>
          <LargeText>
            {currentValue
              ? `Este usuario ya no podrá gestionar los administradores de plataforma de ${companyName}.`
              : `Este usuario podrá gestionar los administradores de plataforma de ${companyName}.`}
          </LargeText>
        </ModalBody>
        <ContainerButtons>
          <Action onClick={handleCloseClick}>Cancelar</Action>
          <Button type="submit" style={{ display: 'flex', alignItems: 'center' }} onClick={handleConfirmClick}>
            Aceptar
          </Button>
        </ContainerButtons>
      </ModalContainer>
    </Modal>
  )
}

export default AdminManagementPermissionModal

